import { Button } from "components/Button";
import { GREEN } from "shared/variables";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import React from "react";
import styles from "./Form.module.css";

export const Form = ({
  buttonLabel = "Versturen",
  children = undefined,
  defaultValues = undefined,
  error = undefined,
  onSubmit = undefined,
  onChange = undefined,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    formState,
    setValue,
  } = useForm({
    defaultValues,
    mode: "onChange",
  });
  const { isSubmitting } = formState;

  const childrenWithRegisterAndError = React.Children.map(children, (child) =>
    React.cloneElement(child, {
      register,
      error: errors && errors[child.props?.name],
    })
  );

  useEffect(() => {
    document.body.style.cursor = isSubmitting ? "wait" : "";
    return () => {document.body.style.cursor = ""};
  }, [isSubmitting]);

  useEffect(() => {
    Object.entries(defaultValues || {}).forEach(([key, value]) =>
      setValue(key, value)
    );
  }, [defaultValues, setValue]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} onChange={onChange}>
      {childrenWithRegisterAndError}
      <Button color={GREEN} disabled={isSubmitting} href={undefined} link={undefined}>
        {buttonLabel}
      </Button>
      {error && <div className={styles.formError}>{error}</div>}
    </form>
  );
};

export const Input = ({
  type = "text",
  label = undefined,
  name = undefined,
  register = undefined,
  error = undefined,
  required = undefined,
  hidden = undefined,
  ...rest
}) => (
  <InputContainer
    label={label}
    error={error}
    required={required}
    style={{ display: !hidden ? "block" : "none" }}
  >
    <input
      className={styles.input}
      type={type}
      name={name}
      {...register(name, { required })}
      {...rest}
    />
  </InputContainer>
);

export const Checkbox = ({
  type = "text",
  label,
  name,
  register,
  error,
  required,
  ...rest
}) => (
  <InputContainer error={error} required={required}>
    <div className={styles.checkboxContainer}>
      <input
        className={styles.checkbox}
        type="checkbox"
        name={name}
        {...register(name, { required })}
        {...rest}
      />
      <span className={styles.fakeCheckbox} />
      <span className={styles.checkboxLabel}>{label}</span>
    </div>
  </InputContainer>
);

export const TextArea = ({
  label = undefined,
  name = undefined,
  register = undefined,
  error = undefined,
  required = undefined,
  ...rest
}) => (
  <InputContainer label={label} error={error} required={required}>
    <textarea
      className={styles.textArea}
      name={name}
      {...register(name, { required })}
      {...rest}
    />
  </InputContainer>
);

export const Select = ({
  label = undefined,
  name = undefined,
  register = undefined,
  error = undefined,
  required = undefined,
  options = undefined,
  ...rest
}) => (
  <InputContainer label={label} error={error} required={required}>
    <div className={styles.selectContainer}>
      <select
        className={styles.select}
        name={name}
        {...register(name, { required })}
        {...rest}
      >
        <option disabled selected></option>
        {options.map(({ value, label }) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>
      <div className={styles.selectArrow} />
    </div>
  </InputContainer>
);

const InputContainer = ({ label = undefined, children = undefined, error = undefined, required = undefined, ...rest }) => (
  <label className={styles.inputContainer} {...rest}>
    {label && (
      <div className={styles.label}>
        {label}
        {!required && <span className={styles.optional}> (optioneel)</span>}
      </div>
    )}
    <div className={error ? styles.errorContainer : null}>{children}</div>
    {error && error.type === "required" && (
      <div className={styles.inputContainerError}>Dit veld is verplicht</div>
    )}
  </label>
);
